// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingFilledSvg from "@ant-design/icons-svg/es/asn/ShoppingFilled";
import AntdIcon from '../components/AntdIcon';

var ShoppingFilled = function ShoppingFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingFilledSvg
  }));
};

ShoppingFilled.displayName = 'ShoppingFilled';
export default React.forwardRef(ShoppingFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ShoppingFilled.js
// module id = 1793
// module chunks = 0